<script>
    import Button from "@smui/button/Button.svelte";

    import Textfield from "@smui/textfield";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import title from "../../components/title";

    import { getObject, setObject } from "../../session";

    export let location;

    let notes = "";

    function next() {
        const order = getObject("order");
        order["notes"] = notes;
        setObject("order", order);
        navigate("/order/review");
    }

    onMount(() => {
        title.set("Catatan");
    });
</script>

<div class="content">
    <div class="text">Mau menambahkan catatan? (Tidak wajib)</div>
    <Textfield
        textarea
        bind:value={notes}
        variant="outlined"
        label="Catatan"
        input$placeholder="Misal: jangan dibanting" />
    <Button on:click={next} variant="unelevated" class="rounded">
        Lanjutkan
    </Button>
</div>
